import { axiosInstance } from '../../axios';
import {
  CreateSkillPayload,
  Skill,
  UpdateSkillPayload,
} from './skill.interface';

export function fetchSkills() {
  return axiosInstance
    .get<Skill[]>('/api/admin/skill')
    .then((response) => response.data);
}

export function createSkill(payload: CreateSkillPayload) {
  return axiosInstance
    .post<Skill>('/api/admin/skill', payload)
    .then((response) => response.data);
}

export function updateSkill(id: string, payload: UpdateSkillPayload) {
  return axiosInstance
    .patch<Skill>(`/api/admin/skill/${id}`, payload)
    .then((response) => response.data);
}

export function deleteSkill(id: string) {
  return axiosInstance
    .delete<Skill>(`/api/admin/skill/${id}`)
    .then((response) => response.data);
}
